import { render } from "./file-chart.vue?vue&type=template&id=d1b8cbc6&ts=true"
import script from "./file-chart.vue?vue&type=script&lang=ts"
export * from "./file-chart.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__